import React from 'react';
import FeaturePage from './FeaturePage';

function ProfitTrackingPage() {
  return (
    <FeaturePage title="Profit Tracking">
      {/* You can add specific content here later */}
    </FeaturePage>
  );
}

export default ProfitTrackingPage; 